import React, { useState, useEffect } from 'react';
import { API_URL } from '../../config';
import { authFetch } from '../../utils';

const RecipientUserForm = ({ user, onSave, onCancel , scrollRef }) => {
  const [form, setForm] = useState({
    name: '',
    phoneNumber: '',
    facility: '',
    receivesAlarmCalls: false,
    receivesAlarmSMS: false,
    riskLevelSMS: 0
  });

  const [showToast, setShowToast] = useState(false);
  const [isLocked, setIsLocked] = useState(false);

  useEffect(() => {
    if (user) setForm(user);
  }, [user]);

  const handleChange = (e) => {
    if (isLocked) return;
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLocked(true);
    const method = user ? 'PUT' : 'POST';
    const url = user ? `${API_URL}/recipients/${user._id}` : `${API_URL}/recipient`;
    const res = await authFetch(url, {
      method,
      body: JSON.stringify(form)
    });

    if (res.ok) {
      const saved = await res.json();
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
        setIsLocked(false);
        onSave(saved);
      }, 2000);
    } else {
      alert('Error al guardar el destinatario. Código: ' + res.status);
      setIsLocked(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '0.75rem',
    fontSize: '1rem',
    borderRadius: '6px',
    border: '1px solid #ccc',
    backgroundColor: isLocked ? '#e9ecef' : '#fff'
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '0.5rem',
    fontWeight: 'bold'
  };

  const sectionStyle = {
    marginBottom: '1.25rem'
  };

  const checkboxGroup = {
    display: 'flex',
    gap: '1rem',
    marginTop: '0.5rem'
  };

  const buttonPrimary = {
    padding: '0.5rem 1.25rem',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: isLocked ? 'not-allowed' : 'pointer',
    opacity: isLocked ? 0.6 : 1
  };

  const buttonSecondary = {
    padding: '0.5rem 1.25rem',
    backgroundColor: '#6c757d',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: isLocked ? 'not-allowed' : 'pointer',
    opacity: isLocked ? 0.6 : 1
  };

  return (
    <>
      <form
        ref={scrollRef}
        onSubmit={handleSubmit}
        style={{
          maxWidth: '600px',
          margin: '2rem auto',
          padding: '2rem',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0,0,0,0.05)'
        }}
      >
        <h3 style={{ textAlign: 'center', marginBottom: '1.5rem', fontSize: '1.5rem' }}>
          {user ? '✏️ Editar Destinatario' : '➕ Crear Destinatario'}
        </h3>

        <div style={sectionStyle}>
          <label style={labelStyle}>Nombre</label>
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Nombre completo"
            required
            style={inputStyle}
            disabled={isLocked}
          />
        </div>

        <div style={sectionStyle}>
          <label style={labelStyle}>Teléfono</label>
          <input
            name="phoneNumber"
            value={form.phoneNumber}
            onChange={handleChange}
            placeholder="Ej. +34 600 123 456"
            required
            style={inputStyle}
            disabled={isLocked}
          />
        </div>

        <div style={sectionStyle}>
          <label style={labelStyle}>Instalación</label>
          <input
            name="facility"
            value={form.facility}
            onChange={handleChange}
            placeholder="Nombre de la instalación"
            required
            style={inputStyle}
            disabled={isLocked}
          />
        </div>

        <div style={sectionStyle}>
          <label style={labelStyle}>Preferencias de Alarma</label>
          <div style={checkboxGroup}>
            <label>
              <input
                type="checkbox"
                name="receivesAlarmCalls"
                checked={form.receivesAlarmCalls}
                onChange={handleChange}
                disabled={isLocked}
              />{' '}
              Recibe llamadas
            </label>
            <label>
              <input
                type="checkbox"
                name="receivesAlarmSMS"
                checked={form.receivesAlarmSMS}
                onChange={handleChange}
                disabled={isLocked}
              />{' '}
              Recibe SMS
            </label>
          </div>
        </div>

        <div style={sectionStyle}>
          <label style={labelStyle}>Nivel de riesgo para SMS (0–4)</label>
          <input
            type="number"
            name="riskLevelSMS"
            value={form.riskLevelSMS}
            onChange={handleChange}
            min="0"
            max="4"
            style={inputStyle}
            disabled={isLocked}
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
          <button type="submit" style={buttonPrimary} disabled={isLocked}>💾 Guardar</button>
          <button type="button" onClick={onCancel} style={buttonSecondary} disabled={isLocked}>❌ Cancelar</button>
        </div>
      </form>

      {showToast && (
        <div style={{
          backgroundColor: '#d4edda',
          color: '#155724',
          padding: '0.75rem 1.25rem',
          borderRadius: '6px',
          border: '1px solid #c3e6cb',
          margin: '1rem auto',
          maxWidth: '400px',
          textAlign: 'center',
          fontSize: '1rem'
        }}>
          ✅ Edición guardada correctamente
        </div>
      )}

    </>
  );
};

export default RecipientUserForm;
